import SendResetPasswordEmail from './SendResetPasswordEmail';

export default SendResetPasswordEmail;
